<div class="information-screen">
  <h2>{{ 'Intellitrailer.BTPermissionInfo.Title' | translate : 'Enable bluetooth'}}</h2>

  <mat-icon>bluetooth</mat-icon>
  <br>
  <b>{{'Intellitrailer.BTPermissionInfo.SubTitle' | translate : 'Bluetooth is required to unlock the trailer' }}</b>
  <p>{{ 'Intellitrailer.BTPermissionInfo.Text' | translate : 'Our trailers are equipped with a bluetooth lock. In order to unlock it you need to allow the app to connect to bluetooth devices.'}}</p>
  @if(!permissionAsked) { <button mat-raised-button (click)="askForPermission()">{{ 'Intellitrailer.BTPermissionInfo.cmdAskPermission' | translate : 'I understand' }}</button>}
  @if(permissionAsked) { <button mat-raised-button (click)="openSettings()">{{ 'Intellitrailer.BTPermissionInfo.cmdOpenSettings' | translate : 'Open settings' }}</button> }
</div>
